
/**
 * Normalises subdomain (removes trailing 'b')
 * and determines the API version ("v1" or "v2").
 */
export function getApiVersion(origin = typeof window === 'undefined' ? '' : window?.location?.origin || '') {

  const rawOriginSubDomain = new URL(origin).hostname.split('.')[0];
  const originSubDomain = rawOriginSubDomain.replace(/b$/, '');
  const apiVersion = rawOriginSubDomain.endsWith('b') ? 'v2' : 'v1';

  return { rawOriginSubDomain, originSubDomain, apiVersion };
}
